/**
 * @generated SignedSource<<8a59501a013fd1a457bbd026461bd395>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard" | "scenariosSection_AtlassianConversationAssistantAgent">;
  readonly " $fragmentType": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef";
};
export type viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef$key = {
  readonly " $data"?: viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_scenarioListRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "agentAbout_AtlassianConversationAssistantAgent_AgentAboutCard"
    },
    {
      "kind": "FragmentSpread",
      "name": "scenariosSection_AtlassianConversationAssistantAgent"
    }
  ],
  "type": "AgentStudioScenariosResult"
};

(node as any).hash = "b63ab11009e4ca29320b8e69d0a10ef8";

export default node;
